import ElementInit from '../../element-ui-expand/src/init';
import deepMerge from "../../../src/utils/deep-merge";
import {isArray, isObject, isString} from "../../../src/utils/util";

const removeEmptyStringProps = function (obj) {
  Object.keys(obj).forEach(name => {
    if(name.endsWith("_")) {
      delete obj[name];
      return true;
    }
    if (name === 'value') return true;
    let value = obj[name];
    if (value === null) {
      delete obj[name];
      return true;
    }
    if (isString(value) && value.trim().length < 1) {
      delete obj[name];
      return true;
    }
  });
  return obj;
};

export const recursionRemoveEmptyStringProps = function (data = {}) {
  let {options = {}, children} = data;
  removeEmptyStringProps(options.props || {});
  removeEmptyStringProps(options.attrs || {});
  if (isArray(children)) {
    children.forEach(child => recursionRemoveEmptyStringProps(child));
  }
  if (isObject(options.scopedSlots)) {
    Object.keys(options.scopedSlots).forEach(name => {
      if (isObject(options.scopedSlots[name])) {
        recursionRemoveEmptyStringProps(options.scopedSlots[name]);
      }
    });
  }
};

export const init = function (data, context) {
  // 深度拷贝, 防止重复初始化,
  // 已知会出现问题: 初始化事件 会 调用原始事件callback, 如果重复初始化会导致事件嵌套重叠, 引起方法多次调用
  data = deepMerge({}, data);
  let ui = data.options.attrs.ui_;
  switch (ui) {
    case 'Element':
      data = ElementInit(data, context);
      break;
    default:
      throw new Error('不支持的ui: ' + ui);
  }
  recursionRemoveEmptyStringProps(data);
  return data;
};



// WEBPACK FOOTER //
// ./packages/form/src/init.js